<style scoped>
    .course-data-type{
        position: relative;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        margin: 2px 0;
        transition: .4s;
    }
    .course-data-type:hover{
        /*background: #e5e5e5;*/
        border-color: #2b85e4;
    }
    .course-data-type-btn{
        float: right;
        cursor: pointer;
    }
    .course-data-type-btn:hover{
        font-weight: bold;
    }
</style>
<template>
    <div class="course-data-type" :class="[`course-data-type-${course_data_type.level}`]">
        <span>{{course_data_type.name}}</span>
        <span>{{course_data_type.name_key}}</span>
        <Icon type="stats-bars" v-if="course_data_type.show_chart"></Icon>
        <span class="course-data-type-btn" @click="editCourseDataType(course_data_type)">编辑</span>
        <template v-if="course_data_type.course_data_types.length">
            <CourseDataTypeEdit
                    @edit="editCourseDataType"
                    :course_data_type="sub_type"
                    v-for="sub_type in course_data_type.course_data_types"
                    :key="sub_type.id">
            </CourseDataTypeEdit>
        </template>
    </div>
</template>
<script>
    export default {
        props: {
            course_data_type: {
                type: Object
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            editCourseDataType(course_data_type){
                this.$emit('edit', course_data_type);
            }
        }
    }
</script>
